module.exports = __webpack_public_path__ + "img/hot-img2.a5f717de.png";